import { Component } from '@angular/core';
import { PartnerUserInfoAddressComponent } from '../../partner-portal/partner-user-info-address/partner-user-info-address.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApplicationService } from 'src/app/services/application.service';
import { AlertService } from 'src/app/services/alert.service';
import { PartnerPortalBreadcrumbsComponent } from 'src/app/components/partner-portal/partner-portal-breadcrumbs/partner-portal-breadcrumbs.component';
import { Breadcrumb } from 'src/app/interfaces/bread-crumb';

@Component({
    imports: [
    TranslateModule,
    RouterModule,
    PartnerUserInfoAddressComponent,
    PartnerPortalBreadcrumbsComponent
],
    selector: 'app-partner-portal-personaldata-page',
    templateUrl: './partner-portal-personaldata-page.component.html',
    styleUrl: './partner-portal-personaldata-page.component.scss'
})
export class PartnerPortalPersonaldataPageComponent {
  id: string;
  breadcrumbs: any[];
  constructor(
    public applicationService: ApplicationService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private translateService: TranslateService,
  ) {
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.id = params['id'];
      }
    });
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.id = params['id'];
      }
    });
    this.breadcrumbs = [
      new Breadcrumb(
        translateService.instant('HOME'),
        applicationService.getSelectCompanyGroupCode() + '/home'
      ),
      new Breadcrumb(translateService.instant('INVOICE_SHIPPING_DETAILS'), '#'),
    ];
  }

  saveForm(form) {
    form.saveForm().then(() => {
      this.alertService.showInfoNotification(this.translateService.instant("SAVED"))
    });
  }
}
